import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { RouterEffects } from 'app/store/common-effects/router.effects';
import { CouriersEffects } from 'app/store/dev/couriers/couriers.effects';
import { DocumentsEffects } from 'app/store/dev/documents/documents.effects';
import { AuthServicesModule } from 'core/http/auth/auth-services';
import { DevServicesModule } from 'core/http/dev/dev-services.module';
import { PageNotFoundModule } from 'project/pages/page-not-found/page-not-found.module';
import { SharedModule } from 'shared/shared.module';
import { DevLayoutComponent } from './dev-layout.component';
import { DevRoutingModule } from './dev-routing.module';

const effects = [
  CouriersEffects,
  DocumentsEffects,
  RouterEffects,
];

@NgModule({
  declarations: [DevLayoutComponent],
  imports: [
    CommonModule,
    SharedModule,
    DevRoutingModule,
    AuthServicesModule,
    DevServicesModule,
    PageNotFoundModule,
    EffectsModule.forFeature(effects),
  ],
  providers: [],
})
export class DevModule {
}
